import React, { useState } from 'react'
import { steps } from '../../../data/home.dummy'
import { ArrowCircleDown } from 'common/components/Icons/ArrowCircleDown'
import { ArrowCircleUp } from 'common/components/Icons/ArrowCircleUp'
import LongArrowDown from './icons/LongArrowDown'

const HowItWorksMobile = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <section
      id='how-it-works-mobile'
      className={`mt-12 ${
        isOpen ? 'absolute top-0 z-50' : 'relative'
      } mx-4 p-4 bg-indigo-50 rounded-lg shadow-md outline outline-[0.2px] outline-indigo-300 flex flex-col gap-4`}
    >
      <button
        className='flex justify-between items-center w-full whitespace-nowrap py-4'
        onClick={() => setIsOpen(!isOpen)}
      >
        <h5 className='text-xs text-slate-900 font-medium'>How it works</h5>
        {isOpen ? (
          <ArrowCircleUp className='w-4 h-4 md:w-6 md:h-6' />
        ) : (
          <ArrowCircleDown className='w-4 h-4 md:w-6 md:h-6' />
        )}
      </button>

      {isOpen && (
        <div className='flex flex-col gap-4 pb-4'>
          {steps.map((step, idx) => (
            <div key={idx} className='flex gap-4 items-start'>
              <div className='flex flex-col items-center gap-2'>
                <div className='w-6 h-6 bg-[#9FCDD7] rounded-full flex justify-center items-center'>
                  <span className='text-sm text-black font-medium'>
                    {idx + 1}
                  </span>
                </div>
                {idx < steps.length - 1 && <LongArrowDown />}
              </div>
              <div className='flex flex-col gap-1'>
                <div className='text-sm text-gray-900 font-medium'>
                  {step.title}
                </div>
                <div className='text-xs text-slate-500 tracking-wide leading-none'>
                  {step.caption}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  )
}

export default HowItWorksMobile
